import { render, staticRenderFns } from "./Prize_shop_wrap.vue?vue&type=template&id=0a98ff96"
import script from "./Prize_shop_wrap.vue?vue&type=script&lang=js"
export * from "./Prize_shop_wrap.vue?vue&type=script&lang=js"
import style0 from "./Prize_shop_wrap.vue?vue&type=style&index=0&id=0a98ff96&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports